var exports = {
  "button": "Button.module__button___RjA3T0",
  "matchSkeletonHeight": "Button.module__matchSkeletonHeight___RjA3T0",
  "small": "Button.module__small___RjA3T0",
  "compact": "Button.module__compact___RjA3T0",
  "superCompact": "Button.module__superCompact___RjA3T0",
  "fitContent": "Button.module__fitContent___RjA3T0",
  "fitContainer": "Button.module__fitContainer___RjA3T0",
  "square": "Button.module__square___RjA3T0",
  "primary": "Button.module__primary___RjA3T0",
  "secondary": "Button.module__secondary___RjA3T0",
  "danger": "Button.module__danger___RjA3T0",
  "inverted": "Button.module__inverted___RjA3T0",
  "invertedOutline": "Button.module__invertedOutline___RjA3T0",
  "ghost": "Button.module__ghost___RjA3T0",
  "recording": "Button.module__recording___RjA3T0",
  "buttonRecordingPulse": "Button.module__buttonRecordingPulse___RjA3T0",
  "spinner": "Button.module__spinner___RjA3T0",
  "spinnerInner": "Button.module__spinnerInner___RjA3T0",
  "spinnerItem": "Button.module__spinnerItem___RjA3T0",
  "spinnerPulsingEllipsis": "Button.module__spinnerPulsingEllipsis___RjA3T0",
  "iconWrapper": "Button.module__iconWrapper___RjA3T0",
  "spinnerWrapper": "Button.module__spinnerWrapper___RjA3T0",
  "hidden": "Button.module__hidden___RjA3T0",
  "grid": "Button.module__grid___RjA3T0",
};

__webpack_require__.r(module.exports = exports);
